import React from "react";
import debug from "debug";
import { FormContext } from "./FormContext";
import { FormStore } from "../formx";

const log = debug("FormXReact:FormX");

export type FormXProps<T> = {
  allowUpdates?: boolean;
  children: React.ReactNode;
  store: FormStore<T>;
};

export class Form<T> extends React.Component<FormXProps<T>> {
  shouldComponentUpdate() {
    return Boolean(this.props.allowUpdates);
  }

  render() {
    log("render");

    const { children, store } = this.props;

    if (!store || !(store instanceof FormStore)) {
      throw new Error("FormX component expects store prop to be instance of FormStore");
    }

    return <FormContext.Provider value={{ store }}>{children}</FormContext.Provider>;
  }
}
